<template>
  <div id="choiceGroupEdit">
    <div class="container">

      <ChoiceNavigation></ChoiceNavigation>

      <div class="page-title">
        <span class="name">{{ data.name[$store.state.locale] || "" }}</span>
        <button class="save btn btn-primary" @click="save"
          v-if="$store.getters.loggedUserCanModifyInventory">{{ $t("save") }}</button>
      </div>

      <Tabs>
        <TabSection title="Groupe de combo">
          <div class="columns">
            <div class="column">

              <div class="group">
                <LocalizedInput :title="$t('name')" :translate="data.name" />
              </div>

              <div class="group">
                <LocalizedInput :title="$t('description')" :translate="data.description" />
              </div>

              <div class="group">
                <label>Combos</label>
                <ListMultiSelect :bank="choiceSelection" :bankTitle="$t('modifiers.list')" :selected="data.itemChoices"
                  :selectedTitle="$t('modifiers.list_selected')"></ListMultiSelect>
              </div>

            </div>
          </div>
        </TabSection>
      </Tabs>

      <div class="footer-actions" v-if="$store.getters.loggedUserCanModifyInventory">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import ChoiceNavigation from '@/components/choices/Navigation.vue';
  import ListMultiSelect from '@/components/tools/ListMultiSelect.vue';
  import { mapActions } from "vuex";
  import LocalizedInput from "@/components/tools/LocalizedInput";

  export default {
    name: "choiceGroupEdit",

    components: { ChoiceNavigation, ListMultiSelect, LocalizedInput },

    data() {
      return {
        inventory: null,
        choiceSelection: [{
          id: null,
          name: { fr: "" }
        }],
        data: {
          id: null,
          name: { fr: "" },
          description: { fr: "" },
          itemChoices: []
        }
      }
    },

    computed: {
      inventoryReference() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
      }
    },

    watch: {
      "$store.getters.isBranchContextInventory"(newValue) {
        if (newValue) {
          window.lockFields(this.$store.getters.getOverloadableFields);
        }
      }
    },

    validate: {
      "data.name.fr": {
        required: false
      }
    },

    async mounted() {
      let choiceGroupId = this.$route.query.id;
      this.inventory = await this.$store.getters.getContextInventory;

      this.$store.commit('showSpinner', true);
      Promise
        .all([
          choiceGroupId ? this.getChoiceGroup({ inventoryId: this.inventoryReference, id: choiceGroupId }) : Promise.resolve(),
          this.getChoices({ inventoryId: this.inventoryReference })
        ])
        .then(([choiceGroup, choices]) => {
          let itemChoices = [];
          if (choiceGroupId && choiceGroup) {
            this.data.id = choiceGroup.id;
            this.data.name = choiceGroup.name;
            this.data.description = choiceGroup.description;
            itemChoices = choiceGroup.itemChoices;
          }
          this.choiceSelection = choices
            .map(c => ({
              id: c.id,
              name: c.placeholder,
              note: c.note
            }));
          this.data.itemChoices = this.choiceSelection.filter(c => itemChoices.indexOf(c.id) > -1);
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);

          if (this.$store.getters.isBranchContextInventory) {
            window.lockFields(this.$store.getters.getOverloadableFields);
          } else if (!this.$store.getters.loggedUserCanModifyInventory) {
            window.lockFields();
          }
        });
    },

    methods: {

      ...mapActions(["getChoices", "getChoiceGroup", "saveChoiceGroup", "createChoiceGroup"]),

      async save() {
        if (!this.$validate.valid()) {
          toast(this.$t("branch.error.required"), "warning");
          this.$validate.validateAllOnce();
          return;
        }
        this.$store.commit("showSpinner", true);
        let copy = JSON.parse(JSON.stringify(this.data));
        copy.itemChoices = copy.itemChoices.map(c => c.id);
        if (this.data.id) {
          let response = await this.saveChoiceGroup({ inventoryId: this.inventoryReference, itemId: this.data.id, data: copy });
          if (!response) {
            toast(this.$t("modifiers.error.save"), "error");
            this.$store.commit("showSpinner", false);
            return;
          }
        } else {
          let response = await this.createChoiceGroup({ inventoryId: this.inventoryReference, data: copy });
          if (!response) {
            toast(this.$t("modifiers.error.save"), "error");
            this.$store.commit("showSpinner", false);
            return;
          }
        }
        this.$store.commit("showSpinner", false);
        this.$router.push(this.$router.buildContext("/choice-groups"));
        toast(this.$t("choices.group_success"), "success");
      }
    }
  }
</script>

<style lang="scss" scoped>
  #choiceGroupEdit {
    display: flex;
  }
</style>
